<template>
    <div>
        <drop-down />
    </div>
</template>

<script>
    import firebase from '@/firebase/firebase'
    import playSound from 'play-sound'
    import DropDown from './DropDown'
    import { mapMutations, mapActions } from 'vuex'

    export default {
        components : {
            DropDown
        },

        data () {
            return {
                
            }
        },

        async mounted () {
            try {
                await this.fetchNotifications()
                let permission = await firebase.messaging().requestPermission()
                let token = await firebase.messaging().getToken({vapidKey : 'BMyPZbd6K_RW_Syltkl68TtZKoPtNhFAssJJqsxoMmhib6waN5XNLq5cHp4YVVs2KyzON5ouPh8IkPQj3Abk23o'})
                
                this.setPushToken(token)

                firebase.messaging().onMessage((payload) => {
                    new Audio(require('@/assets/sounds/PR_Delivery.mp3')).play()
                    this.$notification.info({
                        message: payload.notification.title,
                        description : payload.notification.body
                    })
                })

            } catch (err) {
                console.log('erro:', err)
            }
        },

        methods : {
            ...mapActions('notifications', ['fetchNotifications', 'setPushToken']),
            ...mapMutations('notifications', ['setNewMessage'])
        }
    }
</script>